import { ShopCard } from "draft/types";
import { getRandomInt } from "draft/utils/drafter";


const ffaCardsPool : ShopCard[] = [
    {
        Index: 1,
        Name: "Stage Warp",
        Description: "Ny tilfeldig bane av motsatt type",
        Cost: "1 dl",
        Effects: ["stageWarp"], 

    },
    {
        Index : 2,
        Name : "Ban Fiesta",
        Description : "Ban 2 heroes randomly",
        Cost: "1 dl",
        Effects : ["banFiesta"]
    },
    {
        Index : 3,
        Name : "Sneaky boy",
        Description : "Snik 1 plass i picking-køen",
        Cost: "2 dl",
        Effects : ["sneak"]
    },
    {
        Index : 4,
        Name : "Another one",
        Description : "Legg til 2 nye helter til poolen",
        Cost: "2 dl",
        Effects : ["anotherOne"]
    },

]


export const GetFFACards = () : ShopCard[] => {
    const cards : ShopCard[] = [];

    const banCard : ShopCard = {
        Index: 0,
        Name: "Ban",
        Description: "Ban en helt i fellespotten",
        Cost: "1 dl",
        Effects: ["addBan"], 
    }
    cards.push(banCard);

    let cardPool : ShopCard[] = [...ffaCardsPool]
    for(var i = 0; i < 2; i++){
        const rng = getRandomInt(cardPool.length);

        cards.push(cardPool[rng]);
        cardPool.splice(rng, 1);
    }

    return cards;
}
